import { FluentBundle, FluentResource } from '@fluent/bundle';
import { LocalizationProvider, ReactLocalization } from '@fluent/react';
import { Children, ReactNode, useEffect, useState } from 'react';
import { getMobileAppsFluentResource } from './localization/mobile-apps.page';
import { getPluginManagementFluentResource } from './localization/plugin-management.page';

interface AppLocalizationProviderProps {
    children: ReactNode;
}

export function AppLocalizationProvider(props: AppLocalizationProviderProps) {
    const [l10n, setL10n] = useState<ReactLocalization | null>(null);

    useEffect(() => {
        const bundle = new FluentBundle('en-us');
        bundle.addResource(new FluentResource((window as unknown as { environment: { whiteLabel: { terms: string } } }).environment.whiteLabel.terms));
        const resource = new FluentResource(`
about-buildinfo-heading = Build Info
about-buildinfo-version = Version:
about-buildinfo-date = Date:
about-buildinfo-api = Api:
about-buildinfo-apidocs = Api Docs:
about-gisintegrations-heading = GIS Integrations
about-gisintegrations-username = Username:
about-gisintegrations-integration = Integration:
about-gisintegrations-url = Url:
about-gisintegrations-token = Token:
about-gisintegrations-expiration = Expiration:
about-gisintegrations-notsignedin = Assigned GIS Integrations Not Signed In
app-logout = Logging out of application, please wait...
login-heading = Log In
login-copyright = © 2009–{ $year } Trimble Inc.
login-revision = Revision: { $version }+{ $buildNumber }
login-oauth-options = Ways to login:
login-link-reset-password = Forgot password
login-button-login = Login
login-button-login-loading = Logging in…
login-input-username =
  .label = Username
login-input-password =
  .label = Password
login-powered-by = Powered by
tid-app = Authorize <boldName>{$appName}</boldName>
tid-app-accessing-gis = Accessing the <boldName>{$appName}</boldName> gis integration, please wait…
tid-app-failed-gis-integrations = Failed GIS Integrations
tid-app-processed-gis-integrations = Processed GIS Integrations
tid-app-processed-all-gis-integrations = <boldName>All</boldName> gis integrations have been processed, entering the application now...
tid-app-continue = Continue
tid-app-login = Authorizing with <boldName>TID</boldName>, please wait...
tid-app-logout = Logging out of <boldName>TID</boldName>, please wait...
tid-app-no-gis-integrations = No GIS Integrations could be found
tid-app-permission = We need your permission to access <boldName>{$appName}</boldName>
tid-app-return = Return
`);
        bundle.addResource(resource);
        bundle.addResource(getPluginManagementFluentResource());
        bundle.addResource(getMobileAppsFluentResource());
        changeLocales([bundle]);
    }, []);

    async function changeLocales(bundles: FluentBundle[]) {
        setL10n(new ReactLocalization(bundles));
    }

    if (l10n === null) {
        return <div>Loading…</div>;
    }

    return (
        <>
            <LocalizationProvider l10n={l10n}>
                {Children.only(props.children)}
            </LocalizationProvider>
        </>
    );
}
